import { PhoneNumber } from "@/Common/Api/Contacts/Dto/PhoneNumber";
import { ValidationHelper } from "@/Common/Helpers/ValidationHelper";

interface IPhoneSectionProps {
    phones: PhoneNumber[];
}

function PhoneSection(props: IPhoneSectionProps): JSX.Element {
    const phones = props.phones;
    const validationHelper = new ValidationHelper();

    return (
        <div>
            <div className="view-section-header">
                <h3 className="view-section-title">{cacheStore.GetString("PhoneLabel")}</h3>
            </div>
            <div className="view-section-body">
                {phones.sortByPropertyDesc(c => c.IsPreferred).map((phone: PhoneNumber, idx: number) => {
                    const validationRule = validationHelper.getPhoneNumberValidationRule(phone.CountryLookupId, null); // no need for region when checking for phone number format?
                    const displayFormatSelector: string = validationRule ? validationRule.DisplayFormatSelectorPatern : "";
                    const displayFormatSubstitution: string = (validationRule) ? validationRule.DisplayFormatSubstitution : "";
                    let formattedPhone = validationHelper.getFormatedString(phone.Number, displayFormatSelector, displayFormatSubstitution);

                    if (phone.Extension)
                        formattedPhone += " Ext. " + phone.Extension;

                    return (
                        <div id={"__i" + idx} key={"__k" + idx} style={{ "marginBottom": "10px" }}>
                            <div className="row">
                                <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                                    <label className="form-label">{cacheStore.GetString("TypeLabel")}</label>
                                </div>
                                <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                                    <strong>{cacheStore.GetLocalizedValueByLookupId(phone.ContactPointTypeLookupId)} - {cacheStore.GetLocalizedValueByLookupId(phone.PhoneTypeLookupId)}</strong>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                                    <label className="form-label">{cacheStore.GetString("CountryLabel")}</label>
                                </div>
                                <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                                    <strong>{cacheStore.GetLocalizedValueByLookupId(phone.CountryLookupId)}</strong>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                                    <label className="form-label">{cacheStore.GetString("NumberLabel")}</label>
                                </div>
                                <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                                    <strong>{formattedPhone}</strong>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default PhoneSection;
